import React, {useState} from 'react';
import {RegisterAPI} from "./api";
import {Visibility, VisibilityOff} from '@material-ui/icons';
import '../../css/global.css';
import LoginImg from "../../assets/images/login-removebg-preview.png";
import {toast, ToastContainer} from "react-toastify";

const RegisterPage = () => {
    const [userInfo, setUserInfo] = useState({
        name: '',
        username: '',
        password: '',
        mobile_number: '',
        confirm_password: '',
        company: '',
        phone_number: '',
    });
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);


    const toggleShowPassword = () => setShowPassword(!showPassword);

    const handleRegister = async (e) => {
        e.preventDefault();
        if (userInfo.password !== userInfo.confirm_password) {
            toast.error('رمز عبور و تکرار آن باید یکسان باشد');
            return;
        }

        if (userInfo.username.length !== 10) {
            toast.error('کد ملی باید ده رقم باشد');
            return;
        }
        setLoading(true);
        try {
            const {message} = await RegisterAPI.Register(userInfo);
            toast.success('ثبت نام موفقیت آمیز بود');
            setTimeout(() => {
                window.location.href = '/login';
                setLoading(false);
            }, 1000);
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message);
            setLoading(false);
        }
    };

    return (
        <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <div className="row justify-content-center">
                    <div className="col-12 login-img text-center">
                        <img src={LoginImg} alt="login-img" className="img-fluid"/>
                    </div>
                    <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                        <div className="card rounded-4 border-3 border-dark mb-4">
                            <h5 className="card-header bg-dark text-white text-center">
                                ثبت نام
                            </h5>
                            <div className="card-body">
                                <form onSubmit={handleRegister}>
                                    <label className="mb-1" htmlFor="username">کد ملی</label>
                                    <div className='mb-3'>
                                        <input
                                            type="text"
                                            className="form-control shadow"
                                            name="username"
                                            id="username"
                                            maxLength="50"
                                            placeholder='شماره ملی'
                                            value={userInfo.username}
                                            disabled={loading}
                                            onChange={(e) => setUserInfo({...userInfo, username: e.target.value})}
                                        />
                                    </div>
                                    <div className="mb-1">
                                        <label className="mb-1" htmlFor="name">نام و نام خانوادگی</label>
                                        <div className='mb-3'>
                                            <input
                                                type="text"
                                                className="form-control shadow"
                                                name="name"
                                                id="name"
                                                maxLength="50"
                                                placeholder='نام و نام خانوادگی'
                                                value={userInfo.name}
                                                disabled={loading}
                                                onChange={(e) => setUserInfo({...userInfo, name: e.target.value})}
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-1">
                                        <label className="mb-1" htmlFor="password">رمز عبور</label>
                                        <div className="input-group">
                                            <input
                                                type={showPassword ? 'text' : 'password'}
                                                className="form-control shadow"
                                                name="password"
                                                id="password"
                                                maxLength="50"
                                                placeholder="رمز عبور"
                                                value={userInfo.password}
                                                disabled={loading}
                                                onChange={(e) => setUserInfo({...userInfo, password: e.target.value})}
                                            />
                                            <div onClick={toggleShowPassword} style={{
                                                zIndex: '100000',
                                                cursor: 'pointer',
                                                position: 'absolute',
                                                left: '8px',
                                                top: '6px'
                                            }}>
                                                {showPassword ? <VisibilityOff/> : <Visibility/>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-1">
                                        <label className="mb-1" htmlFor="confirmPassword">تکرار رمز عبور</label>
                                        <div className='mb-3'>
                                            <input
                                                type="password"
                                                className="form-control shadow"
                                                name="confirmPassword"
                                                id="confirmPassword"
                                                maxLength="50"
                                                placeholder='تکرار رمز عبور'
                                                value={userInfo.confirm_password}
                                                disabled={loading}
                                                onChange={(e) => setUserInfo({
                                                    ...userInfo,
                                                    confirm_password: e.target.value
                                                })}
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-5">
                                        <label className="mb-1" htmlFor="mobileNumber">شماره موبایل</label>
                                        <div className='mb-3'>
                                            <input
                                                type="text"
                                                className="form-control shadow"
                                                name="mobileNumber"
                                                id="mobileNumber"
                                                maxLength="50"
                                                placeholder='شماره موبایل'
                                                value={userInfo.mobile_number}
                                                disabled={loading}
                                                onChange={(e) => setUserInfo({
                                                    ...userInfo,
                                                    mobile_number: e.target.value
                                                })}
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-1">
                                        <label className="mb-1" htmlFor="companyName">نام صافکاری</label>
                                        <div className='mb-3'>
                                            <input
                                                type="text"
                                                className="form-control shadow"
                                                name="companyName"
                                                id="companyName"
                                                maxLength="50"
                                                placeholder='نام صافکاری'
                                                value={userInfo.company}
                                                disabled={loading}
                                                onChange={(e) => setUserInfo({
                                                    ...userInfo,
                                                    company: e.target.value
                                                })}
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-1">
                                        <label className="mb-1" htmlFor="phone_number">شماره تلفن</label>
                                        <div className='mb-3'>
                                            <input
                                                type="text"
                                                className="form-control shadow"
                                                name="phone_number"
                                                id="phone_number"
                                                maxLength="50"
                                                placeholder='شماره تلفن'
                                                value={userInfo.phone_number}
                                                disabled={loading}
                                                onChange={(e) => setUserInfo({
                                                    ...userInfo,
                                                    phone_number: e.target.value
                                                })}
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <div className="text-center">
                                            <input
                                                type="submit"
                                                className="btn btn-warning"
                                                value={loading ? 'لطفا صبر کنید ...' : 'ثبت نام'}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div>
                                <div className="text-center">
                                    <input
                                        type="button"
                                        onClick={() => window.location.href = '/login'}
                                        className="btn"
                                        value='ورود به حساب کاربری'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default RegisterPage;